import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { ApirequestService } from 'src/app/api/request/apirequest.service';
import { ApiFunctions } from 'src/app/shared/functions/api-functions';
import { FormFunctions } from 'src/app/shared/functions/form-functions';
import { DropdownsInterface } from 'src/app/shared/interfaces/data/dropdowns-interface';
import { InvoiceInterface } from 'src/app/shared/interfaces/data/invoice-interface';
import { ActionButtonsService } from '../../services/action-buttons.service';
import { NotificationService } from '../../services/notification.service';
import { forkJoin, of, Subscription, throwError } from 'rxjs';
import { Tab } from '../../tab-models/tab.model';
import { TabParamsInterface } from 'src/app/shared/interfaces/tab-params/tab-params-interface';
import { LinesInterface } from 'src/app/shared/interfaces/data/lines-interface';
import { DetailLinesComponent } from '../../components/detail-lines/detail-lines.component';
import { TabsetComponent } from 'ng-uikit-pro-standard';
import { PGAUtils } from 'src/app/shared/functions/pga-utils';
import { DateFormats } from 'src/app/shared/functions/date-formats';
import { ReceiptInterface } from 'src/app/shared/interfaces/data/receipt-interface';
import { LockService } from '../../services/lock.service';
import { LockdataInterface } from 'src/app/shared/interfaces/data/lockdata-interface';
import { FirmAddressInterface } from 'src/app/shared/interfaces/data/firm-address-interface';
import { EntityService } from '../../services/entity.service';
import { catchError } from 'rxjs/operators';
import { DropdownService } from '../../services/dropdown.service';

@Component({
  selector: 'app-invoice',
  templateUrl: './invoice.component.html',
  styleUrls: ['./invoice.component.scss']
})
export class InvoiceComponent implements OnInit, OnDestroy {

  @Input() tab: Tab;
  @Input() data: TabParamsInterface;

  @ViewChild('invoiceTabs', { static: true }) invoiceTabs: TabsetComponent;
  @ViewChild('detailComponent', {static: false}) detailComponent: DetailLinesComponent



  public id: number;
  public dropdowndata
  public loading = false;
  public invoice: InvoiceInterface;
  public receipts: Array<ReceiptInterface>;
  private formFunctions = new FormFunctions;
  public dateFormatter = new DateFormats;

  public detail: Array<any>;

  private utils = new PGAUtils;

  private subscriptions: Array<Subscription> = [];

  public firm_addresses: Array<FirmAddressInterface>;
  public formInvoice: FormGroup;

  public detail_headers: Array<any> = [
    {header: 'Código', class: 'code-column'},
    'Descripción',
    { header: 'Cantidad', class: 'numbers-column'},
    {header: 'Precio', class: 'numbers-column'},
    {header:'%Descuento', class: 'percent-column'},
    {header:'%Impuesto', class: 'percent-column'}
  ]
  public detail_fields_order: Array<any> = [
    {
      control: 'code',
      type: 'text',
      default: '',
      disabled: false,
      addKey: true,
    },
    {
      control: 'description',
      type: 'text',
      default: '',
      disabled: false,
      validate:true,
      validators:[Validators.required],
      error_msg: 'Campo obligatorio',
      addKey: true,
    },
    {
      control: 'quantity',
      type: 'number',
      default: 1,
      disabled: false,
      validate: true,
      validators: [Validators.required],
      error_msg: 'Campo obligatorio'
    },
    {
      control: 'price',
      type: 'number',
      disabled: false,
      default: 0,
      validate: true,
      validators: [Validators.required],
      error_msg: 'Campo obligatorio'
    },
    {
      control: 'discount',
      type: 'number',
      disabled: false,
      default: 0,
      validate: true,
      validators: [Validators.required],
      error_msg: 'Campo obligatorio'
    },
    {
      control: 'taxe_id',
      type: 'select',
      dropdown: 'taxes',
      field_value: 'value',
      addKey: true,
      clear: false,
      listen_changes: true,
      disabled: true,
      default: 1,
    }
  ]


  private unlock_subscription: Subscription;
  private lockdata: LockdataInterface;


  public claim_entity = this._entity.entities.claim;
  public client_entity = this._entity.entities.client;
  public guild_entity = this._entity.entities.guild;
  public serie_entity = this._entity.entities.serie;


  constructor(private _api: ApirequestService, private _lock: LockService, private _apifunctions: ApiFunctions, private _buttons: ActionButtonsService, private _notification: NotificationService, private _entity: EntityService, private _dropdowns: DropdownService) { }

  ngOnInit(): void {
    this.id = +this.data.id;
    this.formInvoice = this.formFunctions.getForm(this.data.entity);
    this.getData();
  }

  ngOnDestroy(): void {
    this.unsubscribeAll()

    this._api.unlockExit(this.lockdata)
  }

  unsubscribeAll(){
    for(let i=0;i<this.subscriptions.length;i++){
      this.subscriptions[i].unsubscribe();
    }

  }

  private getData() {
    this.loading = true;
    this.detailComponent?.detailsForms.clear();

    this.subscriptions.push(
      forkJoin([
        this._api.get(this.data.saveEndpoint + '/' + this.id),
        this._dropdowns.getDropdownsAPI_Observable(this.data.edit_register_dropdowns)
      ])
      .pipe(
        catchError(error => {
          this.loading = false;
          return throwError(error)
        })
      )
      .subscribe(
        responses => {
          this.checkLock(responses.find(response => response.response.hasOwnProperty(this.data.entity)).response)
          this.setDropdowns();

          this.loading = false;
        },
        error => {
          console.log(error)
          this.loading = false;
        }
      )
    );
  }

  private setDropdowns() {
    let data = this.utils.objectDeepCopy(this._dropdowns.getDropdownsObject(this.data.edit_register_dropdowns));
    data.guild = data.guild.filter(guild => guild.enabled == true);
    this.dropdowndata = data;
  }

  private setFirmAddresses(){
    this.loading = true;
    let newurl = new URL(this._api.getAPIEndpoint()+'firmsaddresses');
    let filter_firm = {
      firmaddress: {
        firm_id: this.invoice.firm_id
      }
    }

    newurl.searchParams.append('filters', JSON.stringify(filter_firm));
    newurl.searchParams.append('paginate', JSON.stringify(0));

    this.subscriptions.push(
      this._api.get('firmsaddresses'+newurl.search).subscribe(
        response => {
          this.dropdowndata['firm_addresses'] = response.response.firmaddress;
          this.loading = false;
        },
        error => {
          this.loading = false;
        }
      )
    );
  }

  private checkLock(apiresponse: any): void {
    this.lockdata = this._lock.fillLockdata(apiresponse.lock)
    this.invoice = apiresponse.invoice;
    this.detail = apiresponse.invoice.lines;
    this.receipts = apiresponse.invoice.invoicereceipts;
    this.tab.tabData.headerData = this.invoice.number;

    this.setFirmAddresses();



    if(!this.lockdata.unblock) {
      this.tab.tabLock = true;
      if(this.tab.tabActive) {
        this.openLockModal()
      }
    } else {
      this.setFormData()
    }
  }

  public openLockModal(){
    this._lock.showLockModal(this.lockdata);

    this.unlock_subscription = this._lock.confirmUnblock.subscribe(
      lockdata =>{
        if(lockdata) {
          this.lockdata = this._lock.fillLockdata(lockdata)
          this.tab.tabLock = false;
          this.formInvoice = undefined;
          setTimeout(() => {
            this.formInvoice = this.formFunctions.getForm(this.data.entity);
            this.setFormData();
          },5)
        } else{
          this.setFormData(true)
        }

        this.unlock_subscription.unsubscribe()
      }
    );
  }

  private setFormData(block?: boolean) {
    if(block){
      this.formFunctions.rellenarFormulario(this.formInvoice, this.invoice);
      this.setInvoiceAddress();
      this.setInvoiceProviderName();
      this.formInvoice.disable();
    } else {

      this.formFunctions.rellenarFormulario(this.formInvoice, this.invoice);

      this.setInvoiceAddress();
      this.setInvoiceProviderName();
      this.formInvoice.controls.emission_date.setValue(this.dateFormatter.cambioFormato(this.invoice.emission_date));

      this.subscriptions.push(
        this.formInvoice.valueChanges.subscribe(
          change => {
            this.tab.modifiedData = true;
          }
        )
      )
    }


  }


  private setInvoiceAddress() {
    let address = '';

    if(this.invoice.claim) {
      if(this.invoice.claim?.policy) {
        address = this.invoice.claim.policy.address_complete;
      } else if(this.invoice.claim?.clientaddress) {
        address = this.invoice.claim.clientaddress.address_complete;
      }
    } else if(this.invoice.clientaddress_id) {
      address = this.invoice.clientaddress.address_complete;
    }

    this.formInvoice.controls.invoice_address.setValue(address);
  }

  private setInvoiceProviderName() {
    let provider_name = 'Particular';
    if(this.invoice.provider) {
      provider_name = this.invoice.provider.name;
      if(this.invoice.subprovider) {
        provider_name += ' ('+this.invoice.subprovider.name+')';
      }
    }

    this.formInvoice.controls.invoice_provider_name.setValue(provider_name);
  }

  disableChanges(): boolean {
    let readonly = false;
    if(!this.lockdata?.unblock) {
      readonly = true;
    } else {
      if(this.invoice && (this.invoice.typecondition_id == 2 || this.invoice.type_state_id > 1)) {
        readonly = true;
      }
    }

    return readonly;
  }

  changeSelect(tipo: string, valor) :void{
    this.formInvoice.controls[tipo]['controls'].id.setValue(valor);
    this.formInvoice.controls[tipo]['controls'].id.markAsDirty();
  }

  onSubmit() {

    this._buttons.setLoading(true);

    this.formInvoice.markAllAsTouched();

    let line_form_error = false;
    this.detailComponent.detailsForms.controls.forEach(
      form => {
        form.markAllAsTouched();
      }
    )
    for (let index = 0; index < this.detailComponent.detailsForms.controls.length; index++) {
      if(this.detailComponent.detailsForms.controls[index].invalid) {
        line_form_error = true;
        break;
      }
    }


    if(this.formInvoice.valid && !line_form_error) {
      const params = {};

      //Datos Factura
      this.formFunctions.fillFormParams(this.formInvoice, this.data.entity, params)

      //Datos Líneas
      params['invoicelines']= [];
      this.detailComponent.pushDetailsToMaster(params['invoicelines']);

      if(params['invoicelines'].length > 0) {
        params[this.data.entity]['total'] = this.detailComponent.total_lineas
        params[this.data.entity]['total_price'] = this.detailComponent.total_price
        params[this.data.entity]['total_taxe'] = this.detailComponent.total_taxe
      }

      this.subscriptions.push(
        this._api.put(this.data.saveEndpoint+'/'+this.data.id, JSON.stringify(params)).subscribe(
          resp=>{
            this.tab.modifiedData = false;
            this.formInvoice.markAsPristine();
            this.unsubscribeAll();
            this.getData()
            this._buttons.reloadListTab(this.data.saveEndpoint)
            this._buttons.setLoading(false);
            this._notification.notificacionOK(resp.response[this.data.entity])
          },
          err => {
            this._buttons.setLoading(false);
          }
        )
      )
    } else {
      this._buttons.setLoading(false);
    }


  }

  reloadInvoice() {
    this.tab.modifiedData = false;
    this.formInvoice.markAsPristine();
    this.unsubscribeAll();
    this.getData()
  }
}
